import { createSlice } from "@reduxjs/toolkit";
import { getAdminListAPI } from "../../services/adminManagement";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getAdminListSlice = createSlice({
  name: "getAdminList",
  initialState: data,
  reducers: {
    getAdminListInfo(state) {
      state.isLoading = true;
    },
    getAdminListInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getAdminListInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getAdminListInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getAdminListHandler = (payload) => async (dispatch) => {
  try {
    dispatch(getAdminListAction.getAdminListInfo());
    const response = await getAdminListAPI(payload);
    dispatch(getAdminListAction.getAdminListInfoSuccess(response));
  } catch (e) {
    dispatch(getAdminListAction.getAdminListInfoFailure(e));
  }
};

export default getAdminListSlice.reducer;
export const getAdminListAction = getAdminListSlice.actions;
